/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    if (!navigation) return;
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();


/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* Data subnav hamburger + current section label — mobile only */
(function () {
    var btn = document.querySelector('.ukpr-subnav-hamburger');
    var drawer = document.getElementById('ukpr-subnav-drawer');
    var label = document.getElementById('ukpr-subnav-current-label');

    // Populate current section label
    if (label) {
        var currentNavItem = document.querySelector('.ukpr-data-subnav-inner .nav .nav-current > a');
        if (currentNavItem) {
            label.textContent = currentNavItem.textContent.trim();
        } else if (document.querySelector('.ukpr-data-subnav-home.nav-current')) {
            label.textContent = 'Home';
        }
    }

    if (!btn || !drawer) return;

    btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = drawer.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });

    document.addEventListener('click', function (e) {
        if (drawer.classList.contains('is-open') && !drawer.contains(e.target) && e.target !== btn) {
            drawer.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
            drawer.setAttribute('aria-hidden', 'true');
        }
    });
})();
/* Seat Ticker Bar
 * Fetches /changing-seats.json, shuffles items, and animates a continuous
 * horizontal scroll. Desktop only (CSS hides on ≤767px).
 */
document.addEventListener('DOMContentLoaded', function () {
    var ticker = document.getElementById('ukpr-ticker');
    var track  = document.getElementById('ukpr-ticker-track');
    if (!ticker || !track) return;

    var PARTY_PROP_MAP = {
        LAB:    '--color-party-lab',
        CON:    '--color-party-con',
        REFORM: '--color-party-reform',
        LIB:    '--color-party-lib',
        SNP:    '--color-party-snp',
        GREEN:  '--color-party-green',
        PLAID:  '--color-party-plaid',
    };

    function partyColor(abbrev) {
        var prop = PARTY_PROP_MAP[abbrev];
        if (prop) {
            var val = getComputedStyle(document.documentElement).getPropertyValue(prop).trim();
            if (val) return val;
        }
        return '#888';
    }

    function shuffle(arr) {
        for (var i = arr.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
        }
        return arr;
    }

    function buildItem(seat) {
        var a = document.createElement('a');
        a.href = '/seats/' + encodeURIComponent(seat.code);
        a.className = 'ukpr-ticker-item';

        var name = document.createElement('span');
        name.className = 'ukpr-ticker-seat';
        name.textContent = seat.name;

        var colon = document.createElement('span');
        colon.className = 'ukpr-ticker-colon';
        colon.textContent = ':';

        var winner = document.createElement('span');
        winner.className = 'ukpr-ticker-winner';
        winner.setAttribute('data-party', seat.winner);
        winner.textContent = seat.winner;
        winner.style.color = partyColor(seat.winner);

        var from = document.createElement('span');
        from.className = 'ukpr-ticker-from';
        from.textContent = 'gain from';

        var loser = document.createElement('span');
        loser.className = 'ukpr-ticker-loser';
        loser.setAttribute('data-party', seat.loser);
        loser.textContent = seat.loser;
        loser.style.color = partyColor(seat.loser);

        a.appendChild(name);
        a.appendChild(colon);
        a.appendChild(winner);
        a.appendChild(from);
        a.appendChild(loser);
        return a;
    }

    fetch('/changing-seats.json')
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (seats) {
            if (!seats || !seats.length) return;
            shuffle(seats);

            // Build two copies for seamless loop
            var fragment = document.createDocumentFragment();
            var allSeats = seats.concat(seats);
            allSeats.forEach(function (seat) {
                fragment.appendChild(buildItem(seat));
            });
            track.appendChild(fragment);

            // Set animation duration: measure half the track width (one copy) at ~180px/s
            requestAnimationFrame(function () {
                var halfWidth = track.scrollWidth / 2;
                var duration = Math.max(10, Math.round(halfWidth / 180));
                track.style.setProperty('--ticker-duration', duration + 's');
            });

            ticker.removeAttribute('aria-hidden');
        })
        .catch(function () {
            // Fail silently — ticker stays hidden
        });
});
